<script setup lang="ts">
import type { IconName } from '../icons'
import UiIcon from './UiIcon.vue'

// compact: the shorter version for sections inside a card (dashboard, report and detail-tab sections).
withDefaults(defineProps<{ icon: IconName; title: string; text?: string; tone?: 'accent' | 'danger'; compact?: boolean }>(), {
  tone: 'accent',
  text: undefined,
})
</script>

<template>
  <div class="ui-empty" :class="{ 'ui-empty--compact': compact }" :role="tone === 'danger' ? 'alert' : undefined">
    <span class="ui-empty__icon" :class="`ui-empty__icon--${tone}`"><UiIcon :name="icon" :stroke-width="2" /></span>
    <h2 class="ui-empty__title">{{ title }}</h2>
    <p v-if="text" class="ui-empty__text">{{ text }}</p>
    <slot />
  </div>
</template>

<style scoped>
.ui-empty {
  padding: 64px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
}
.ui-empty__icon {
  display: inline-flex;
  margin-bottom: 8px;
  color: var(--border);
}
.ui-empty__icon :deep(svg) {
  width: 32px;
  height: 32px;
}
.ui-empty--compact {
  padding: 40px 24px;
}
.ui-empty--compact .ui-empty__icon :deep(svg) {
  width: 24px;
  height: 24px;
}
.ui-empty__icon--danger {
  color: var(--tint-danger-fg);
}
.ui-empty__title {
  margin: 0;
  font-size: var(--type-headline-size);
  line-height: var(--type-headline-line);
  font-weight: var(--weight-medium);
  color: var(--text-label);
}
.ui-empty__text {
  margin: 0;
  max-width: 420px;
  font-size: var(--type-body-size);
  color: var(--text-secondary);
}
.ui-empty > :deep(:not(.ui-empty__icon, .ui-empty__title, .ui-empty__text)) {
  margin-top: 12px;
}
</style>
